// extracted by mini-css-extract-plugin
module.exports = {"count":"AuthorListView__count","countEmpty":"AuthorListView__countEmpty"};